import {
  GET_USER,
  GET_USER_FAIL,
  GET_USER_SUCCESS,
  GET_USER_DETAILS,
  GET_USER_DETAILS_FAIL,
  GET_USER_DETAILS_SUCCESS,
  ADD_NEW_USER,
  ADD_USER_SUCCESS,
  ADD_USER_FAIL,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  UPDATE_PW_USER,
  UPDATE_PW_USER_SUCCESS,
  UPDATE_PW_USER_FAIL,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
  EXPORT_USER_EXCEL,
  EXPORT_USER_EXCEL_SUCCESS,
  EXPORT_USER_EXCEL_FAIL,
  RESET_USER_STATE,
  RESET_USER_ATTACHMENT_STATE,
} from "./actionTypes";

export const getUser = ({length, page, name, status, sort, sort_by}) => ({
  type: GET_USER,
  payload: {length, page, name, status, sort, sort_by},
});

export const getUserSuccess = user => ({
  type: GET_USER_SUCCESS,
  payload: user,
});

export const getUserFail = error => ({
  type: GET_USER_FAIL,
  payload: error,
});

export const getUserDetails = ({id}) => ({
  type: GET_USER_DETAILS,
  payload: {id},
});

export const getUserDetailsSuccess = user => ({
  type: GET_USER_DETAILS_SUCCESS,
  payload: user,
});

export const getUserDetailsFail = error => ({
  type: GET_USER_DETAILS_FAIL,
  payload: error,
});

//add 
export const addNewUser = user => ({
  type: ADD_NEW_USER,
  payload: user,
});

export const addUserSuccess = user => ({
  type: ADD_USER_SUCCESS,
  payload: user,
});

export const addUserFail = error => ({
  type: ADD_USER_FAIL,
  payload: error,
});

//update 
export const updateUser =({id, user}) => ({
  type: UPDATE_USER,
  payload:{id, user},
});

export const updateUserSuccess = user => ({
  type: UPDATE_USER_SUCCESS,
  payload: user,
});

export const updateUserFail = error => ({
  type: UPDATE_USER_FAIL,
  payload: error,
});

//delete 
export const deleteUser =({id}) => ({
  type: DELETE_USER,
  payload:{id},
});

export const deleteUserSuccess = user => ({
  type: DELETE_USER_SUCCESS,
  payload: user,
});

export const deleteUserFail = error => ({
  type: DELETE_USER_FAIL,
  payload: error,
});

//update pw
export const updatePwUser =({id, data}) => ({
  type: UPDATE_PW_USER,
  payload:{id, data},
});

export const updatePwUserSuccess = user => ({
  type: UPDATE_PW_USER_SUCCESS,
  payload: user,
});

export const updatePwUserFail = error => ({
  type: UPDATE_PW_USER_FAIL,
  payload: error,
});


//exprt excel
export const exportUserExcel = user => ({
  type: EXPORT_USER_EXCEL,
  payload: user,
});

export const exportUserExcelSuccess = user => ({
  type: EXPORT_USER_EXCEL_SUCCESS,
  payload: user,
});

export const exportUserExcelFail = error => ({
  type: EXPORT_USER_EXCEL_FAIL,
  payload: error,
});



//reset
export const resetUserState = () => {
  return {
      type: RESET_USER_STATE,
  }
}

//reset attachment
export const resetUserAttachmentState = () => {
  return {
      type: RESET_USER_ATTACHMENT_STATE,
  }
}

